export class MSColumnSaveModalHelpTextConstants {
  static readonly HelpText =
    "This view is available only to you. Give it a name to help you find it in the future. You can overwrite an existing view by giving it the same name.";
}
export class MSColumnSettingsDefaultValueConstants {
  static readonly ZeroDelayTimeMs = 0;
  static readonly StandardDelayTimeMs = 50;
  static readonly IgnoredHeaderColumnCount = 2;
  static readonly DefaultColumnSettingId = "DefaultColumnSetting";
  static readonly DefaultColumnSettingName = "SuitabilityHub Default";
}
